import React from 'react'
import ReactDOM from 'react-dom'

import { App } from './App'

/**
 * support for multiple lists
 */
const journalLists = document.querySelectorAll('[data-journal]')

journalLists.forEach((journalList) => ReactDOM.render(<App />, journalList))
